import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategorySection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100/70">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 md:mb-12">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
              内容分类
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
              探索多元内容类型
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              从剧情到纪录片，从短片到动画，在这里发现你感兴趣的每一种国产视频类型
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {categories.filter((c) => c.slug !== 'all').map((category) => (
              <Link
                key={category.slug}
                to={`/category/${category.slug}`}
                className="group bg-background-50 rounded-xl p-5 md:p-6 text-center transition-all duration-300 hover:bg-primary-50/50 cursor-pointer no-underline"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 md:mb-4 rounded-xl bg-background-100 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                  <i className={`${category.icon} text-xl md:text-2xl text-foreground-600 group-hover:text-primary-600 transition-colors`}></i>
                </div>
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 mb-1">
                  {category.name}
                </h3>
                <p className="text-xs text-foreground-400 leading-relaxed line-clamp-2">
                  {category.description}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}